/* eslint-disable react/no-danger */
import { CLOUD, IRON, SKY } from 'styles/Colors';
import { getData } from 'helpers/RequestHelper';
import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';

const footerStyle = {
  minHeight: '20rem',
  background: CLOUD,
  borderRadius: '3px',
  color: IRON,
  fontFamily: 'Arimo',
  fontSize: '0.8125rem',
  fontWeight: 400,
  lineHeight: '1.125rem',
  padding: '2rem 1rem',
  WebkitFontSmoothing: 'auto',

  a: {
    color: IRON,
    textDecoration: 'underline',

    '&:hover, &:focus': {
      color: `${SKY} !important`
    }
  },

  p: {
    marginBottom: '0.375rem',
    textAlign: 'justify'
  },

  sup: {
    fontSize: 'smaller'
  }
};

function DynamicFooter({ additionalFooterStyle = {} }) {
  const [footer, setFooter] = useState(null);

  useEffect(() => {
    getData({
      url: '/api/v1/dynamic_footers'
    }).then((res) => {
      setFooter(res.data.footer_content);
    });
  }, []);

  return (
    <div
      id='dynamic-footer'
      css={[footerStyle, additionalFooterStyle]}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(footer) }}
    />
  );
}

export default (props) => <DynamicFooter {...props} />;
